function OnlineOrderingApiClientBase(baseURL, username, password, franchiseID) {
    var _self = this;

    if (baseURL.charAt(baseURL.length - 1) == '/')
        baseURL = baseURL.slice(0, -1);

    this.baseURL = baseURL;
    this.username = username;
    this.password = password;
    this.franchiseID = franchiseID;
    this.providerName = 'Orders';
    this.errorMessages = {
        unauthorizedMessage: 'Authorization has been denied for this request.',
        invalidRefreshToken: 'invalid_grant',
        failedToFetch: 'Failed to fetch'
    };

    var errorEventHandler = new OnlineOrderingApiClientEventHandler(this);
    this.OnErrorOccured = function (event) {
        if (typeof event === 'function')
            errorEventHandler.attach(event);
        else {
            var promise = _self.init();
            errorEventHandler.invoke(event);
            return promise;
        }
    };

    this.orders = {};
    this.orders.maps = {};
    this.orders.maps.closest = {};
    this.orders.maps.search = {};
    this.orders.order = {};
    this.orders.order.repeat = {};
    this.orders.location = {};
    this.orders.location.validate = {};
    this.orders.location.distance = {};
    this.orders.payment = {};
    this.orders.payment.pay = {};
    this.orders.payment.notifyRedirect = {};
    this.orders.payment.notify = {};
    this.orders.payment.finalize = {};
    this.orders.payment.success = {};
    this.orders.payment.cancel = {};
    this.orders.payment.error = {};
    this.orders.payment.pay.token = {};
    this.orders.payment.status = {};
    this.orders.branches = {};
    this.orders.branches.get = {};
    this.orders.branches.update = {};
    this.orders.cart = {};
    this.orders.cart.update = {};
    this.orders.cart.add = {};
    this.orders.cart.remove = {};
    this.orders.cart.eligible = {};
    this.orders.cart.refresh = {};
    this.orders.cart.totals = {};
    this.orders.checkout = {};
    this.orders.checkout.delivery_times = {};
    this.orders.checkout.submit = {};
    this.orders.checkout.cards = {};
    this.orders.checkout.dates = {};
    this.orders.checkout.dates.range = {};
    this.orders.franchises = {};
    this.orders.franchises.get = {};
    this.orders.menu = {};
    this.orders.menu.items = {};
    this.orders.menu.items.get = {};
    this.orders.history = {};
    this.orders.accounts = {};
    this.orders.accounts.login = {};
    this.orders.accounts.logout = {};
    this.orders.accounts.recover = {};
    this.orders.accounts.register = {};
    this.orders.accounts.get = {};
    this.orders.accounts.update = {};
    this.orders.accounts.create = {};
    this.orders.accounts.password = {};
    this.orders.accounts.password.update = {};
    this.orders.echo = {};
    this.orders.echo.ping = {};
    this.orders.echo.ip = {};

    /*
    Request data structure:
    {
        Lat: Decimal,
        Lng: Decimal,
        MeterRadius: Int32,
        MinRowCount: Int32,
        MaxRowCount: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.maps.closest.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/maps/closest/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        SearchText: String,
        Lat: Decimal,
        Lng: Decimal,
        MeterRadius: Int32,
        MinRowCount: Int32,
        MaxRowCount: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.maps.search.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/maps/search/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        OrderID: Int32,
        MembershipUserID: Guid,
        UserID: Int32
    }
    */
    this.orders.order.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/order/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/order/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        ID: Int32,
        GUID: Guid,
        FranchiseID: Int32,
        MembershipUserID: Guid,
        UserID: Int32
    }
    */
    this.orders.order.repeat.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/order/repeat/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/order/repeat/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        Address: String,
        Province: String,
        Country: String,
        AreaCode: String
    }
    */
    this.orders.location.validate.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/location/validate/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/location/validate/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32,
        Address: String,
        Province: String,
        Country: String,
        AreaCode: String
    }
    */
    this.orders.location.distance.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/location/distance/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/location/distance/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        MembershipUserID: Guid,
        PaymentReference: Guid,
        Token: String
    }
    */
    this.orders.payment.pay.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/pay/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/payment/pay/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    */
    // [AllowAnonymous]
    this.orders.payment.notifyRedirect.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/notifyRedirect/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    */
    // [AllowAnonymous]
    this.orders.payment.notify.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/notify/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        PaymentReference: Guid,
        ExternalPaymentReference: String,
        PaymentStatus: String,
        Exception: Exception
    }
    */
    this.orders.payment.finalize.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/finalize/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/payment/finalize/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        PaymentReference: Guid,
        MembershipUserID: Guid,
        FranchiseID: Int32,
        CartGuid: Guid,
        InvoiceUrl: String
    }
    */
    // [AllowAnonymous]
    this.orders.payment.success.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/success/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        PaymentReference: Guid,
        MembershipUserID: Guid,
        FranchiseID: Int32,
        CartGuid: Guid,
        InvoiceUrl: String
    }
    */
    // [AllowAnonymous]
    this.orders.payment.cancel.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/cancel/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        PaymentReference: Guid,
        MembershipUserID: Guid,
        FranchiseID: Int32,
        CartGuid: Guid,
        InvoiceUrl: String
    }
    */
    // [AllowAnonymous]
    this.orders.payment.error.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/error/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        PaymentProvider: String,
        PaymentReference: Guid,
        FranchiseID: Int32,
        BranchID: Int32,
        PaymentKey: String
    }
    */
    // [AllowAnonymous]
    this.orders.payment.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        MembershipUserID: Guid,
        PaymentReference: Guid,
        Token: String
    }
    */
    // [AllowAnonymous]
    this.orders.payment.pay.token.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/pay/token/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        PaymentReference: Guid
    }
    */
    // [AllowAnonymous]
    this.orders.payment.status.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/payment/status/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.branches.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/branches/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        BranchID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.branches.get.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/branches/get/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32,
        BranchID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.branches.update.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/branches/update/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.cart.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32,
        SKU: String,
        ProductID: Int32,
        Quantity: Int32,
        Modifiers: CartProductModifiers,
        SpecialInstructions: String
    }
    */
    // [AllowAnonymous]
    this.orders.cart.update.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/update/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        Guid: Guid,
        FranchiseID: Int32,
        SKU: String,
        ProductID: Int32,
        Quantity: Int32,
        Modifiers: CartProductModifiers,
        SpecialInstructions: String
    }
    */
    // [AllowAnonymous]
    this.orders.cart.add.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/add/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        Sku: String,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.cart.remove.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/remove/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.cart.eligible.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/eligible/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.cart.refresh.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/refresh/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        Guid: Guid,
        FranchiseID: Int32,
        Gratuity: Double,
        DeliveryFee: Double
    }
    */
    this.orders.cart.totals.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/cart/totals/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/cart/totals/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        Guid: Guid,
        FranchiseID: Int32,
        BranchID: Nullable`1,
        MembershipUserID: Guid
    }
    */
    this.orders.checkout.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/checkout/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/checkout/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        BranchID: Int32,
        ScheduledDay: DateTime
    }
    */
    this.orders.checkout.delivery_times.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/checkout/delivery_times/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/checkout/delivery_times/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        TableNo: Nullable`1,
        Tab: Boolean,
        Pickup: Boolean,
        Delivery: Boolean,
        Payment: Boolean,
        GoodsAmount: Nullable`1,
        ReferenceNo: String,
        DeliveryFee: Decimal,
        Address: String,
        Province: String,
        Country: String,
        AreaCode: String,
        FranchiseID: Int32,
        FranchiseName: String,
        BranchID: Int32,
        UserID: Int32,
        MembershipUserID: Guid,
        Gratuity: Double,
        DeliveryDateTime: Nullable`1,
        FullDeliveryAddress: String
    }
    */
    this.orders.checkout.submit.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/checkout/submit/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/checkout/submit/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        GUID: Guid,
        FranchiseID: Int32,
        MembershipUserID: Guid
    }
    */
    this.orders.checkout.cards.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/checkout/cards/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/checkout/cards/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    // [AllowAnonymous]
    this.orders.checkout.dates.range.v1 = function () {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/checkout/dates/range/v1', 'GET', null)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        FranchiseName: String
    }
    */
    // [AllowAnonymous]
    this.orders.franchises.get.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/franchises/get/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    // [AllowAnonymous]
    this.orders.franchises.v1 = function () {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/franchises/v1', 'GET', null)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        FranchiseName: String
    }
    */
    // [AllowAnonymous]
    this.orders.menu.items.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/menu/items/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        ID: Int32,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.menu.items.get.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/menu/items/get/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        ID: Int32,
        GUID: Guid,
        FranchiseID: Int32,
        MembershipUserID: Guid,
        UserID: Int32
    }
    */
    this.orders.history.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/history/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/history/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        Username: String,
        Password: String,
        Persist: Nullable`1,
        Token: String,
        FranchiseID: Int32,
        BotCheck: String
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.login.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/login/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        Token: String,
        FranchiseID: Int32
    }
    */
    this.orders.accounts.logout.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/logout/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/accounts/logout/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        EmailAddress: String,
        FranchiseID: Int32
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.recover.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/recover/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        ActivationUrl: String,
        BotCheck: String,
        FirstName: String,
        LastName: String,
        FullName: String,
        Mobile: String,
        Email: String
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.register.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/register/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        MembershipUserID: Guid
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.get.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/get/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        FranchiseID: Int32,
        ID: Int32,
        FirstName: String,
        LastName: String,
        MobileNo: String,
        EmailAddress: String,
        Address: String,
        Province: String,
        Country: String,
        AreaCode: String,
        Notes: String
    }
    */
    this.orders.accounts.update.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/update/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                .then(function (result) {
                    if (result.message)
                        throw result;
                    resolve(result);
                })
                .catch(error => {
                    if (error.message == _self.errorMessages.unauthorizedMessage && localStorage.getItem('OrdersUserRefreshToken'))
                        _self.refreshToken(localStorage.getItem('OrdersUserRefreshToken')).then(function () {
                            fetchData('api/orders/accounts/update/v1', 'POST', data, localStorage.getItem('OrdersUserToken'))
                                .then(function (data) { resolve(data); })
                                .catch(function (error) { reject(error); });
                        }).catch(function (error) {
                            errorEventHandler.invoke(error);
                            reject(error);
                        });
                    else {
                        errorEventHandler.invoke(error);
                        reject(error);
                    }
                });
        });
    };
    /*
    Request data structure:
    {
        Token: String,
        FranchiseID: Int32,
        EmailAddress: String,
        Password: String,
        ConfirmPassword: String
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.create.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/create/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    /*
    Request data structure:
    {
        OldPassword: String,
        Password: String,
        ConfirmPassword: String,
        FranchiseID: Int32,
        MembershipUserID: Guid
    }
    */
    // [AllowAnonymous]
    this.orders.accounts.password.update.v1 = function (data) {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/accounts/password/update/v1', 'POST', data)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    // [AllowAnonymous]
    this.orders.echo.ping.v1 = function () {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/echo/ping/v1', 'GET', null)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    // [AllowAnonymous]
    this.orders.echo.ip.v1 = function () {
        return new Promise((resolve, reject) => {
            fetchData('api/orders/echo/ip/v1', 'GET', null)
                .then(function (result) {
                    resolve(result);
                })
                .catch(error => {
                    errorEventHandler.invoke(error);
                    reject(error);
                });
        });
    };
    this.authenticate = function (username, password) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + 'Token';
            var fetchBody = 'grant_type=password';
            fetchBody += '&username=' + encodeURIComponent(username);
            fetchBody += '&password=' + encodeURIComponent(password);
            fetchBody += '&providerName=' + encodeURIComponent(_self.providerName);
            fetchBody += '&providerArg1=' + encodeURIComponent(this.franchiseID);
            var fetchInitParams = {
                method: 'POST',
                body: fetchBody,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            };

            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    if (data != null && data['access_token']) {
                        localStorage.setItem('OrdersUserToken', data['access_token']);
                        localStorage.setItem('OrdersUserRefreshToken', data['refresh_token']);
                        resolve(data);
                    }
                    else {
                        reject(); // TODO: Create new error object to pass to reject.
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    reject(error);
                });

        });

        return promise;
    };
    this.refreshToken = function (refreshToken) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + 'Token';
            var fetchBody = 'grant_type=refresh_token';
            fetchBody += '&refresh_token=' + encodeURIComponent(refreshToken);

            var fetchInitParams = {
                method: 'POST',
                body: fetchBody,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                }
            };

            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    if (data != null && data['access_token']) {
                        localStorage.setItem('OrdersUserToken', data['access_token']);
                        localStorage.setItem('OrdersUserRefreshToken', data['refresh_token']);
                        resolve(data);
                    }
                    else {
                        var error = new Error(data.error);
                        reject(error);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });

        });

        return promise;
    };
    function fetchData(callURL, method, data, token) {
        var promise = new Promise((resolve, reject) => {

            var url = _self.baseURL + '/' + callURL;
            var fetchInitParams = {
                headers: {
                    'content-type': 'application/json'
                }
            };

            if (data) {
                fetchInitParams.method = method;
                fetchInitParams.body = JSON.stringify(data);
            }

            if (token) {
                fetchInitParams.headers['Authorization'] = 'Bearer ' + token;
            }


            var result = fetch(url, fetchInitParams);

            result
                .then((res) => res.text())
                .then((text) => text.length ? JSON.parse(text) : null)
                .then(function (data) {
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });

        return promise;
    }
}
function OnlineOrderingApiClientEventHandler(owner) {
    var sender = owner;
    var eventHandlers = [];

    this.attach = function (eventHandler) {
        eventHandlers.push(eventHandler);
    };
    this.invoke = function (event) {
        for (var i = 0; i < eventHandlers.length; i++) {
            if (eventHandlers[i]) {
                eventHandlers[i](sender, event);
            }
        }
    };
    this.clear = function () {
        eventHandlers = [];
    };
}
export { OnlineOrderingApiClientBase, OnlineOrderingApiClientEventHandler };